import { get } from "lodash";
import { parseOptions } from "../utils/parse-options";
export function useEntityOptions(entity) {
  return parseOptions(get(entity, 'options.text', '{}'));
}
;